export default __webpack_public_path__ + "static/media/AnimalMondey01_03.8a6fffae.png";